/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, February 13th 2023, 5:00:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const CarCostBg = styled.div.attrs(props => ({
    bgColor: props.bgColor,
}))`
display: flex;
border-radius: 5px;
// min-width: 10rem;
// max-width: 10rem;
background-color: ${props => props.bgColor == "CITYCAR" ? props.theme.colors.second : props.bgColor == "SUV" ? props.theme.colors.third : props.bgColor == "UTILITY" ? props.theme.colors.fourth : props.bgColor == "SEDAN" ? props.theme.colors.fifth : props.bgColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
transition: 0.3s ease;
`;

export default CarCostBg;
